import React, { useMemo } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from '@material-ui/core/styles';

/**
 * @param {{ 
 *   groupObjects?: Array<{ id: string, name?: string }>, 
 *   groupListK?: string[],
 *   className?: string,
 *   title?: string
 * }} props
 */

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  labelName: {
    fontFamily: 'VodafoneRg-bold',
    margin: '1rem 0 1rem 0',
    fontSize: '1.5rem',
    textAlign: 'left',
    color: '#333',
    display: 'block',
  },

}))


const MatchedGroupNames = ({
  groupObjects = [],
  groupListK = [],
  className = "ds",
  title = "Communities Invited Name:",
}) => {
  // 1) Filter: only groups whose id appears in groupListK
  // 2) Sort: ascending by name, locale-aware, case-insensitive
  const classes = useStyles()
  const matchedGroups = useMemo(() => {
    if (!Array.isArray(groupObjects) || !Array.isArray(groupListK)) return [];

    const idSet = new Set(groupListK);

    const filtered = groupObjects.filter(
      (g) => g && typeof g.id === "string" && idSet.has(g.id)
    );

    const byNameAsc = (a, b) =>
      (a?.name ?? "").localeCompare(b?.name ?? "", undefined, {
        sensitivity: "base",
      });

    return typeof filtered.toSorted === "function"
      ? filtered.toSorted(byNameAsc) // modern, non-mutating
      : filtered.slice().sort(byNameAsc); // fallback for older runtimes
  }, [groupObjects, groupListK]);

  return (
    <div>
      <h3 className={classes.labelName}>{title}</h3>

      <List className={className}>
        {matchedGroups.length === 0 ? (
          <ListItemText primary="No groups found" />
        ) : (
          matchedGroups.map((group) => (
            <ListItem key={group.id} >
              <ListItemAvatar>
                <Avatar>{group?.name?.[0]?.toUpperCase() || "?"}</Avatar>
              </ListItemAvatar>
              <ListItemText >{group?.name || "(unnamed group)"}</ListItemText>
            </ListItem>
          ))
        )}
      </List>
    </div>
  );
};

export default React.memo(MatchedGroupNames);